import {Badge} from 'antd';
import {useMemo} from 'react';
import {EnabledStatus} from '../../Stores/commonStore';

export interface StatusTagConfig {
    color: string;
    text: string;
}

interface Props {
    status: any;
    field?: {
        enabledKey?: string;
        enabledText: string;
        disabledKey?: string;
        disabledText: string;
    };
    config?: Record<string, StatusTagConfig>;
}
const Index = ({
    status,
    field = {
        enabledText: '启用',
        disabledText: '停用',
    },
    config,
}: Props) => {
    const isTrue = useMemo(() => {
        if (status === EnabledStatus.Enabled) {
            return true;
        }
        if (status === field?.disabledKey) {
            return false;
        }
        if (status === field?.enabledKey) {
            return true;
        }
        return status;
    }, [status]);

    if (config) {
        return (
            <Badge color={config[status]?.color} text={config[status]?.text} />
        );
    }

    return (
        <Badge
            status={isTrue ? 'success' : 'error'}
            text={isTrue ? field?.enabledText : field?.disabledText}
        />
    );
};

export default Index;
